import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('cbdce-account-welcome', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
